import { render, staticRenderFns } from "./ChatLog.vue?vue&type=template&id=ea80bbb8&scoped=true&"
import script from "./ChatLog.vue?vue&type=script&lang=js&"
export * from "./ChatLog.vue?vue&type=script&lang=js&"
import style0 from "./ChatLog.vue?vue&type=style&index=0&id=ea80bbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea80bbb8",
  null
  
)

export default component.exports